import { toWidgetOrigin } from "../widget-origin";

// The exact URL the checkout iframe loads: the ticket link with its origin swapped
// to the preview widget when one is configured (`toWidgetOrigin` — a no-op
// otherwise, and idempotent on an already-swapped link), plus `isPunchup=true` (a
// constant, non-identifying mode flag) and nothing else. Buyer identity is
// delivered by postMessage, not the URL, so this URL is the same for every user
// and therefore cacheable at the edge. prewarm fetches THIS url so it primes the
// very cache entry the real iframe navigation will hit — the swap living HERE is
// what keeps that true on a cross-env preview.
export const tixologiWidgetSrc = (ticketLink: string): string => {
  try {
    const url = new URL(toWidgetOrigin(ticketLink));
    url.searchParams.set("isPunchup", "true");
    return url.toString();
  } catch {
    return ticketLink;
  }
};

// Warms the checkout iframe's critical path before the user commits to opening it
// (pointerenter/touchstart on a Buy button). The widget HTML is served by a Cloud
// Function behind Fastly with `s-maxage` (TIC-543): one no-cors fetch primes DNS, TLS,
// the shared edge cache, the function instance, and the event API — so the real iframe
// navigation moments later is served hot. Identity params are deliberately NOT included:
// the edge caches by full URL path and the warmed entry must not carry user identifiers.
const warmedUrls = new Set<string>();

export const prewarmTixologiCheckout = (ticketUrl: string | undefined) => {
  if (typeof window === "undefined" || !ticketUrl) return;

  const src = tixologiWidgetSrc(ticketUrl);
  if (warmedUrls.has(src)) return;
  warmedUrls.add(src);

  try {
    void fetch(src, {
      mode: "no-cors",
      credentials: "omit",
    }).catch(() => {
      // Best-effort: a failed warmup must never surface; the real load will retry.
    });
  } catch {
    // Ignore — same reasoning as above.
  }
};
